import React, { useContext } from 'react';
import { shape, func, string } from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { isSTH, productShape } from '../../helpers/pod-fulfillment-utils';

export const CheckNearByStore = (props) => {
  const { channel } = useContext(ExperienceContext);
  const { product, onCheckNearbyStoresClick, nearbyStoreName } = props;
  const { storeId, storeName } = useStore();

  let host = 'https://www.homedepot.com';

  if (typeof window !== 'undefined') {
    host = window.location.origin.match(/local/g)
      ? 'https://www.homedepot.com'
      : window.location.origin;
  }

  const cartReqParams = {
    itemId: product.identifiers.itemId,
    host,
    keyword: storeId,
    channel,
    isShipToHomeEligible: isSTH(product),
    alterBrowserHistory: true
  };

  return (
    <>
      {/* eslint-disable-next-line */}
      <a
        className="store__link store__store-name"
        onClick={(event) => {
          if (onCheckNearbyStoresClick) {
            onCheckNearbyStoresClick();
          }
          window.LIFE_CYCLE_EVENT_BUS.trigger('cart.select-store', {
            cartReqParams
          });
        }}
      >
        {nearbyStoreName || storeName}
      </a>
    </>
  );
};

CheckNearByStore.propTypes = {
  product: shape({ productShape }).isRequired,
  onCheckNearbyStoresClick: func,
  nearbyStoreName: string,
};

CheckNearByStore.defaultProps = {
  onCheckNearbyStoresClick: () => {},
  nearbyStoreName: null,
};
